import { checkRegistrationWithCookie } from '@musinsa/apis-curator';
import { SERVICE, type ServiceType } from '@musinsa/packages-device-detection';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import {
  type CheckRegistrationServiceRequest,
  CheckRegistrationServiceRequestDtoScheme,
  type CheckRegistrationServiceResponse,
  CheckRegistrationServiceResponseDtoScheme,
} from './checkRegistration.dto';

const generateRedirectPath = (xPlatform: ServiceType) => (isRegistered: boolean) => {
  if (xPlatform === SERVICE.MUSINSA) {
    return isRegistered ? '/curator/me/pro' : '/curator/intro/pro';
  } else {
    return isRegistered ? '/me' : '/intro';
  }
};

export const checkRegistrationService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(CheckRegistrationServiceRequestDtoScheme),
    async (request: CheckRegistrationServiceRequest): Promise<CheckRegistrationServiceResponse> => {
      const getRedirectPath = generateRedirectPath(request.xPlatform);
      try {
        const apiResponse = await checkRegistrationWithCookie(
          request.cookieHeader || '',
          request.xPlatform,
        );

        // 🔥 API 응답 null 체크 추가
        if (!apiResponse || typeof apiResponse.registered !== 'boolean') {
          console.warn('[checkRegistrationService] Invalid API response:', apiResponse);

          // 안전한 기본값 반환
          return {
            isRegistered: false,
            redirectPath: getRedirectPath(false),
          };
        }
        const response = {
          isRegistered: apiResponse.registered,
          redirectPath: getRedirectPath(apiResponse.registered),
        };

        return response;
      } catch (error) {
        console.error('[checkRegistrationService] API call failed:', error);

        // 🔥 에러 발생 시 안전한 기본값 반환
        return {
          isRegistered: false,
          redirectPath: getRedirectPath(false),
        };
      }
    },
    validateServiceResponse(CheckRegistrationServiceResponseDtoScheme),
  ),
);
